// extracted by mini-css-extract-plugin
export default {"iframeWrapper":"styles_iframeWrapper__k7qhV","iframe":"styles_iframe__jAyHO","iframeLoaded":"styles_iframeLoaded__JOxJ8","panoramaIframe":"styles_panoramaIframe__Pl1Ta"};